<template>
  <div class="animated fadeIn">
    <b-alert variant="danger" show v-if="errorMessage">{{errorMessage}}</b-alert>
    <b-card v-if="loaded">
      <b-card-body>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col md="1" cols="2">
                <b-row>
                  <b-col sm="11" class="text-center" style="background-color: #82d0f5; color: white;">
                    <h4 style="margin-top: 10px; margin-bottom: 10px;"><img src="/site/img/icone_link_pagina.png" style="max-width: 40%;"></h4>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="11" cols="10" style="background-color: #82d0f5; color: white;">
                <h4 style="margin-top: 10px; margin-bottom: 10px;">Link da Página</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="11" cols="12" offset-md="1" style="padding-left: 0px;">
                Escolha o link da sua página. Apenas letras e números. Sem espaços pontos ou outros caracteres especiais.
                <b-row style="margin-top: 10px;">
                  <b-col cols="12">
                    <div class="float-left" style="margin-top: 5px;">https://sites.sleeker.com.br/{{siteConfiguration.slug}}/</div>
                    <div class="float-left desktop" style="margin-left: 5px; min-width: 60%;">
                      <b-input style="background-color: #ddf2fc; width: 100%;" v-model="page.slug"></b-input>
                    </div>
                    <div class="float-left mobile" style="margin-left: 5px; width: 100%;">
                      <b-input style="background-color: #ddf2fc; width: 100%;" v-model="page.slug"></b-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" style="margin-top: 10px;" v-show="page.slug">
            <b-row>
              <b-col md="1" cols="2">
                <b-row>
                  <b-col md="11" cols="10" class="text-center" style="background-color: #82d0f5; color: white;">
                    <h4 style="margin-top: 10px; margin-bottom: 10px;"><img src="/site/img/icone_tipo_de_pagina.png" style="max-width: 40%;"></h4>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="11" cols="10" style="background-color: #82d0f5; color: white;">
                <h4 style="margin-top: 10px; margin-bottom: 10px;">Tipo de Página</h4>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" style="margin-top: 10px;" v-show="page.slug">
            <b-row>
              <b-col md="11" cols="12" offset-md="1" style="padding-left: 0px;">
                <b-form-group v-if="page && !page.siteTemplateId">
                  <b-form-radio v-model="page.type" name="some-radios" value="leads">{{getTypeName("leads")}}</b-form-radio>
                  <b-form-radio v-model="page.type" name="some-radios" value="sales">{{getTypeName("sales")}}</b-form-radio>
                  <b-form-radio v-model="page.type" name="some-radios" value="thankyou">{{getTypeName("thankyou")}}</b-form-radio>
                </b-form-group>
                <b-input v-else-if="page" disabled style="background-color: #ddf2fc;" :value="getTypeName(page.type)"></b-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" style="margin-top: 15px;" v-show="page.slug">
            <b-row>
              <b-col md="1" cols="2">
                <b-row>
                  <b-col sm="11" class="text-center" style="background-color: #82d0f5; color: white;">
                    <h4 style="margin-top: 10px; margin-bottom: 10px;"><img src="/site/img/icone_template_pagina.png" style="max-width: 40%;"></h4>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="11" cols="10" style="background-color: #82d0f5; color: white;">
                <h4 style="margin-top: 10px; margin-bottom: 10px;">Template da Página</h4>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-if="page && page.slug && !page.siteTemplateId" sm="12">
            <b-row style="margin-top: 10px;">
              <b-col md="11" cols="10" offset-sm="1" style="padding-left: 0;">
                Escolha abaixo o template que quer usar no seu site:
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
              <b-col sm="11" offset-sm="1" style="padding-left: 0;">
                <b-row>
                  <b-col sm="2" cols="6" v-for="template in availableFilteredTemplates" :key="template._id">
                    <b-row>
                      <b-col @click="selectTemplate(template)" cols="12" style="border-color: #8ddcf0; margin-bottom: 5px;" :style="{'border-style': (selectedTemplate && selectedTemplate == template ? 'solid' : 'none')}">
                        <img :src="template.thumbnail" style="max-width: 100%"/>
                      </b-col>
                      <b-col sm="6">
                        <b-button @click="openDemo(template)" class="shadow" block style="background-color: #5a9dbd; color: white;">Ver demo</b-button>
                      </b-col>
                      <b-col sm="6">
                        <b-button @click="selectTemplate(template)" class="shadow" block style="background-color: #77c365; color: white;">Escolher</b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-else-if="page && page.slug && page.type" v-show="page.slug">
            <b-row style="margin-top: 10px;">
              <b-col md="11" cols="10" offset-sm="1" class="text-center">
                <b-button @click="editPage()" pill class="shadow" style="background-color: #5a9dbd; color: white;">Editar Layout da Página</b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" style="margin-top: 15px;"  v-show="page.slug">
            <b-row>
            <b-col md="1" cols="2">
              <b-row>
                <b-col sm="11" class="text-center" style="background-color: #82d0f5; color: white;">
                  <h4 style="margin-top: 10px; margin-bottom: 10px;"><img src="/site/img/icone_acao_botao.png" style="max-width: 20%;"></h4>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="11" cols="10" style="background-color: #82d0f5; color: white;">
              <h4 style="margin-top: 10px; margin-bottom: 10px;">Ação do Botão</h4>
            </b-col>
          </b-row>
          <b-col md="11" cols="12" offset-sm="1" style="padding-left: 0px; margin-top: 10px;">
            <b-input style="background-color: #ddf2fc;" v-model="page.action" placeholder="Cole aqui o link para onde as pessoas serão encaminhadas."></b-input>
          </b-col>
          </b-col>
        </b-row>
        <b-row style="margin-top: 20px;" v-show="page.slug">
          <b-col sm="3" offset-sm="9" class="text-right">
            <b-button v-if="siteConfiguration._id && !saving" class="shadow" block style="background-color: #77c365; color: white;" @click="saveConfiguration()">Salvar configurações</b-button>
            <spinner v-else/>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <spinner v-else/>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";
import Spinner from "./Spinner.vue"


export default {
  name: 'SitePage',
  data () {
    return {
      isMobile: isMobile,
      availableTemplates: [],
      selectedTemplate: undefined,
      siteConfiguration: {},
      errorMessage: "",
      pages: [],
      page: [],
      loaded: false,
      saving: false
    }
  },
  computed: {
    availableFilteredTemplates: function () {
      if (this.page && this.page.type) {
        return this.availableTemplates.filter(t => t.type === this.page.type);
      }
      
      return [];
    }
  },
  methods: {
    openDemo: function(template) {
      window.open("https://sites.sleeker.com.br/preview/" + template._id, "_blank");
    },
    selectTemplate: function(template) {
      this.saveConfiguration(true).then(() => {
        service.setSitePageTemplate(this.page._id, template._id).then(() => {
          this.editPage();
        });
      });
    },
    getTypeName: function(type) {
      if (type == 'leads') {
        return "Captura de Leads";
      } else if (type == 'sales') {
        return "Vendas";
      } else if (type == 'thankyou') {
        return "Página de Obrigado";
      }
      return "";
    },
    editPage: function () {
      if (this.page.falapersonal) {
        this.$router.push('/site/admin-editor/' + this.page._id);
      } else {
        this.$router.push('/site/editor/' + this.page._id);
      }
    },
    saveConfiguration: function(preventRedirect) {
      this.saving = true;
      return new Promise((resolve, reject) => {
        service.saveSitePageConfiguration(this.page).then(result => {
          this.errorMessage = "";
          this.page = result.sitePage;
          if (!preventRedirect) {
            this.$router.push('/site/home');
          }
          this.saving = false;
          resolve();
        }).catch(error => {
          if (error && error.message) {
            this.errorMessage = error.message;
          } else {
            this.errorMessage = "Houve um erro. Por favor, tente novamente ou procure o suporte.";
          }
          this.saving = false;
          reject();
        });
      });
    }
  },
  created() {
    let vm = this;

    service.getMe().then(function(me) {
        vm.me = me;
        service.getSiteByUserId(me._id).then(function(result) {
          if (result.site) {
            vm.siteConfiguration = result.site;
            vm.pages = result.pages;
            vm.selectedTemplate;
            if (vm.$route.params.id) {
              vm.page = vm.pages.filter(p => p._id == vm.$route.params.id)[0];

              if(!vm.page.type) {
                vm.page.type = "leads";
              }
              vm.loaded = true;
            } else {
              vm.page = {
                slug: "",
                idUser: vm.siteConfiguration.idUser,
                idSite: vm.siteConfiguration._id,
                type: "leads"
              }
              vm.loaded = true;
            }
          } else {
            vm.siteConfiguration = {
              slug: "",
              instagram: "",
              whatsapp: "",
              email: "",
              idUser: request.session.user._id
            }
            vm.loaded = true;
          }
        });

        service.getAvailableSiteTemplates().then(result => {
          vm.availableTemplates = result.availableTemplates;

          if (vm.siteConfiguration && vm.siteConfiguration.siteTemplateId) {
            for (let key in vm.availableTemplates) {
              if (vm.availableTemplates[key]._id == vm.siteConfiguration.siteTemplateId) {
                vm.selectedTemplate = vm.availableTemplates[key];
                break;
              }
            }
          }
        });
    });
  },
  components: {Spinner}
}
</script>

<style scoped>

</style>
